export default __webpack_public_path__ + "static/media/welcom3.40987214.jpg";